import {DocumentNode} from "@apollo/client";
import {
  CreateSubscriptionPlanPaymentFromAdminPanelDocument,
  GetPaymentsHistoryBySchoolDocument,
  GetSubscriptionPlansV2Document,
  HandlePaymentActivationDocument,
  DeletePaymentDocument,
  PaymentType,
} from "../../../generated/graphql";

export enum SchoolPaymentsEnum {
  subscriptionPlans = "subscriptionPlans",
  paymentsHistory = "paymentsHistory",
  createPayment = "createPayment",
  activatePayment = "activatePayment",
  deletePayment = "deletePayment",
};

export const DocumentsMap = new Map<SchoolPaymentsEnum, DocumentNode>([
  [SchoolPaymentsEnum.subscriptionPlans, GetSubscriptionPlansV2Document],
  [SchoolPaymentsEnum.paymentsHistory, GetPaymentsHistoryBySchoolDocument],
  [SchoolPaymentsEnum.createPayment, CreateSubscriptionPlanPaymentFromAdminPanelDocument],
  [SchoolPaymentsEnum.activatePayment, HandlePaymentActivationDocument],
  [SchoolPaymentsEnum.deletePayment, DeletePaymentDocument],
]);

export const CustomErrorMessagesMap = new Map<SchoolPaymentsEnum, string>([
  [SchoolPaymentsEnum.subscriptionPlans, "Ошибка получения планов подписки"],
  [SchoolPaymentsEnum.paymentsHistory, "Ошибка получения истории платежей"],
  [SchoolPaymentsEnum.createPayment, "Ошибка создания платежа"],
  [SchoolPaymentsEnum.activatePayment, "Ошибка активации платежа"],
  [SchoolPaymentsEnum.deletePayment, "Ошибка удаления платежа"],
]);

export const NO_MANAGER_ERROR = "Failed to create subscription plan payment from admin panel You are not manager of this school";

export const GqlErrorMessagesMap = new Map<string, string>([
  ["You are not permitted for this action", "У вас нет прав на выполнение данного действия"],
  [NO_MANAGER_ERROR, "Ошибка создания платежа. Только менеджер школы может оформить подписку."]
]);

export const CommonPaymentTypeMap = new Map<PaymentType, string>([
  [PaymentType.Manual, "Безнальная (ручная)"],
  [PaymentType.Promotion, "Маркетинговая акция"],
  [PaymentType.Technical, "Технический"],
]);

export const PersonalPaymentTypeMap = new Map<PaymentType, string>([
  [PaymentType.Fondy, "Fondy"],
  [PaymentType.Stripe, "Stripe"],
]);

export const CombinedPaymentTypeMap = new Map<PaymentType, string>([
  [PaymentType.Fondy, "Fondy"],
  [PaymentType.Stripe, "Stripe"],
  [PaymentType.Manual, "Безнальная (ручная)"],
  [PaymentType.Promotion, "Маркетинговая акция"],
  [PaymentType.Technical, "Технический"],
]);
